import FormDatePicker from '@views/components/Inputs/FormDatePicker';
import { Button, Col, Form, Row } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import Paper from '@/views/components/Paper/Paper';
import { INITIAL_TRAILER_DETAILS } from '@/views/pages/Savers/TrailerManagement/constants';

import { TAB_KEYS } from '../Quote/constants';

const DestinationDetailsGrid = ({
  formTrailerRequestManagement,
  dropdownState,
  editMode,
  requestUserType,
  activeTabName,
  setPickupFormValues,
  setDeliveryFormValues,
  isMultiple,
}) => {
  const handleAddDestination = (add) => {
    const formValues = formTrailerRequestManagement.getFieldsValue();
    const lastDestination = formValues.destLocations?.[formValues.destLocations.length - 1];
    // biome-ignore lint/correctness/noUnusedVariables: removing destination consignee from destination locations
    const { destConsignee, ...lastDestinationWithoutConsignee } = lastDestination || {};
    const newDestination = lastDestination
      ? { ...lastDestinationWithoutConsignee }
      : INITIAL_TRAILER_DETAILS.destLocations[0];
    add(newDestination);
  };

  const handleFormChangeDestination = (event, name) => {
    const { id, value, validity } = event.target;
    const isValidValue = validity.valid ? value : '';
    const val = isValidValue || '0';
    const parsedVal = Math.round(Number.parseInt(val) / 23);

    const currentValues = formTrailerRequestManagement.getFieldsValue();

    if (currentValues.destLocations && currentValues.destLocations.length > 0) {
      const updatedDestLocations = currentValues.destLocations.map((entry) => {
        const updatedEntry = { ...entry };

        switch (id) {
          case 'desttxtSoftWeight':
            updatedEntry.destSoftWeight = val;
            updatedEntry.destSoftOks = parsedVal;
            break;
          case 'desttxtMiscWeight':
            updatedEntry.destMiscWeight = val;
            updatedEntry.destMiscOks = parsedVal;
            break;
          case 'desttxtBookWeight':
            updatedEntry.destBookWeight = val;
            updatedEntry.destBookOks = parsedVal;
            break;
          default:
            updatedEntry[name] = val;
            break;
        }

        return updatedEntry;
      });

      formTrailerRequestManagement.setFieldsValue({
        destLocations: updatedDestLocations,
      });
    }
  };
  const handleDateForDestination = (value, name) => {
    const currentValues = formTrailerRequestManagement.getFieldsValue();

    if (currentValues.destLocations && currentValues.destLocations.length > 0) {
      const updatedDestLocations = currentValues.destLocations.map((entry) => {
        const updatedEntry = { ...entry };
        updatedEntry[name] = value;
        return updatedEntry;
      });

      formTrailerRequestManagement.setFieldsValue({
        destLocations: updatedDestLocations,
      });
    }
  };

  const removeFromList = (fieldName, indexToRemove) => {
    const currentValues = formTrailerRequestManagement.getFieldsValue();
    const updatedList = [...(currentValues[fieldName] || [])];
    updatedList.splice(indexToRemove, 1);

    formTrailerRequestManagement.setFieldsValue({
      [fieldName]: updatedList,
    });

    if (activeTabName === TAB_KEYS.PICKUP || !isMultiple) {
      setPickupFormValues((prev) => ({
        ...prev,
        [fieldName]: updatedList,
      }));
    } else {
      setDeliveryFormValues((prev) => ({
        ...prev,
        [fieldName]: updatedList,
      }));
    }
  };
  return (
    <Col xs={48} sm={24}>
      <Paper className="mb-5">
        <Form.List name="destLocations">
          {(fields, { add, remove }) => (
            <>
              <div className="card-header p-8">
                <Row gutter={10}>
                  <Col sm={18} className="d-flex align-items-center">
                    <span>Destination Details</span>
                  </Col>
                  <Col sm={6} className="text-right">
                    <div className="mt-3">
                      <Button
                        onClick={() => handleAddDestination(add)}
                        size="small"
                        type="default"
                        icon={<PlusOutlined />}
                      >
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="card-body">
                <table className="w-100 origindetails">
                  <thead>
                    <tr>
                      <th className="background-header text-white fixed fixed-top shadow-none" width="150px">
                        Consignee
                      </th>
                      <th className="background-header text-white fixed fixed-top shadow-none trailer-request-management-fixed-width">
                        ETA
                      </th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Soft Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Soft OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Misc Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Misc OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Book Weight</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Book OKs</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">Furn</th>
                      <th className="background-header text-white fixed fixed-top shadow-none">OLI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fields.map(({ key, name }) => (
                      <tr key={key}>
                        <td className="center-align">
                          <FormSelectBox
                            editMode={editMode}
                            name={[name, 'destConsignee']}
                            margin="m-0"
                            options={dropdownState.partnerLocationOptions}
                            loading={dropdownState.loading.partnerLocations}
                            placeholder="Select Destination Location"
                            labelInValue
                            disabled={activeTabName.includes('Delivery') && name === 0}
                          />
                        </td>
                        <td className="center-align">
                          <FormDatePicker
                            disabled={name !== 0}
                            name={[name, 'destETA']}
                            margin="m-0"
                            allowClear={false}
                            onChange={(e) => handleDateForDestination(e, 'destETA')}
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destSoftWeight']}
                            editMode={editMode}
                            onChange={(e) => handleFormChangeDestination(e, 'destSoftWeight')}
                            id="desttxtSoftWeight"
                            placeholder="Soft Weight"
                            readOnly
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destSoftOks']}
                            readOnly
                            editMode={editMode}
                            placeholder="Soft OKs"
                            id="desttxtSoftOks"
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destMiscWeight']}
                            editMode={editMode}
                            onChange={(e) => handleFormChangeDestination(e, 'destMiscWeight')}
                            readOnly
                            placeholder="Misc Weight"
                            id="desttxtMiscWeight"
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destMiscOks']}
                            readOnly
                            editMode={editMode}
                            placeholder="Misc Oks"
                            id="desttxtMiscOks"
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destBookWeight']}
                            onChange={(e) => handleFormChangeDestination(e, 'destBookWeight')}
                            editMode={editMode}
                            placeholder="Book Weight"
                            readOnly
                            id="desttxtBookWeight"
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destBookOks']}
                            readOnly
                            editMode={editMode}
                            placeholder="Book Oks"
                            id="desttxtBookOks"
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destFurn']}
                            editMode={editMode}
                            placeholder="Furn"
                            readOnly
                            id="desttxtFurn"
                            onChange={(e) => handleFormChangeDestination(e, 'destFurn')}
                          />
                        </td>
                        <td className="center-align">
                          <FormInput
                            margin="mb-0"
                            pattern="[0-9]*"
                            className="form-control form-control-sm"
                            type="text"
                            name={[name, 'destOLI']}
                            editMode={editMode}
                            placeholder="OLI"
                            readOnly
                            id="desttxtOLI"
                            onChange={(e) => handleFormChangeDestination(e, 'destOLI')}
                          />
                        </td>
                        {fields.length > 1 && name !== 0 && (
                          <td className="center-align">
                            <Button
                              onClick={() => {
                                removeFromList('destLocations', name);
                                remove(name);
                              }}
                              size="small"
                              type="default"
                              icon={<MinusOutlined />}
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Form.List>
      </Paper>
    </Col>
  );
};

export default DestinationDetailsGrid;
